import { useContext } from 'react';
import { FeatureFlagsContext, FeatureFlagsState } from '@/contexts/contexts';
import { FeatureFlag } from '@bariendo/lib/constants';

/**
 * Hook to access feature flags from context
 * Use this instead of useFeatureFlag directly in components
 */
function useFeatureFlags(): FeatureFlagsState {
  const context = useContext(FeatureFlagsContext);

  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }

  return context;
}

/**
 * Convenience hook for checking a single flag
 */
export function useFeatureFlagEnabled(flag: FeatureFlag): boolean {
  const { isEnabled } = useFeatureFlags();
  return isEnabled(flag);
}

/**
 * Convenience hook for checking a single flag
 */
export function useFeatureFlagEnabledMap(): Record<string, boolean> {
  const { flagsMap } = useFeatureFlags();
  return flagsMap;
}
